import Rover from '@rover/globals/Rover';
import type { Query } from '@rover/utilities/query';

import getUrlParameter from './getUrlParameter';
import { addEventParamsToUrl } from './url.server';

export { addEventParamsToUrl } from './url.server';

Rover.utils = Rover.utils || {};
Rover.utils.getUrlParameter = getUrlParameter;

Rover.utils.hasHashParam = (name: string): boolean => {
  if (window.location.hash) {
    const hash = window.location.hash.substring(1);

    if (hash.indexOf(name) !== -1) {
      return true;
    }
  }

  return false;
};

export const redirect = (url: string | Location): void => {
  // `window` is also `typeof globalThis`, which doesn't allow setting `location` to a string
  // https://github.com/microsoft/TypeScript/issues/48949
  (window as Window).location = url;
};

// Our types for `URLSearchParams` are incorrect – it does implement Symbol.iterator
declare global {
  interface URLSearchParams {
    entries(): IterableIterator<[string, string]>;
    [Symbol.iterator](): IterableIterator<[string, string]>;
  }
}

export const getQueryParams = (queryString?: string): Query => {
  let queryStringToProcess = queryString;

  if (!queryStringToProcess && window) {
    queryStringToProcess = window.location.search;
  }
  const params = new URLSearchParams(queryStringToProcess);

  return Array.from(params).reduce((queryParams, [key, paramString]) => {
    const paramsArray = params.getAll(key);
    const value = paramsArray.length > 1 ? paramsArray : paramString;
    return { ...queryParams, [key]: value };
  }, {});
};

declare global {
  interface Window {
    isRoverURL(url: string): boolean;
  }
}

window.isRoverURL = (url: string): boolean =>
  url.indexOf('//') === -1 ||
  url.indexOf(Rover.urls.base) !== -1 ||
  url.indexOf('//localhost') !== -1 ||
  url.indexOf('//0.0.0.0') !== -1 ||
  url.indexOf('//127.0.0.1') !== -1;

export default { ...Rover.utils, redirect, addEventParamsToUrl };
